import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const contractAPI = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<Contract>>('/api/info/contracts', { params }).then(({ data }) => data),
  update: (id: number | string, data: Omit<ContractFormPayload, 'account'>) =>
    http.put<unknown>(`/api/edit/contracts/${id}`, { data }),
  create: (data: ContractFormPayload) => http.post<unknown>(`/api/add/contracts`, { data }),
  delete: (id: number | string) => http.delete<unknown>(`/api/delete/contracts/${id}`),
  detail: (id: number | string) => http.get<Contract>(`/api/info/contracts/${id}`).then(({ data }) => data),
  history: (id: number | string) =>
    http.get<SaleHistory<Contract>[]>(`/api/info/history_contracts/${id}`).then(({ data }) => data),

  list_student_in_class: (id: number | string) =>
    http.get<ListData<StudentInClass>>(`/api/info/class/${id}/contracts`).then(({ data }) => data),

  list_supplies: (id: number | string) =>
    http.get<ListData<ContractSupply>>(`/api/info/contracts/${id}/supplies`).then(({ data }) => data),
  list_supplies_by_contract: (class_id: number | string, contract_id: number | string) =>
    http
      .get<ListData<SuppliesByContract>>(`/api/info/class/${class_id}/account_contract/${contract_id}/supply`)
      .then(({ data }) => data),
  update_supplies: (id: number | string, data: ContractSupplyPayload) =>
    http.patch(`/api/edit/contracts/${id}/supplies`, { data }),
};

export const contractQuery = {
  list: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetContracts', params] as const,
      queryFn: () => contractAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
  detail: (id: number | string) =>
    ({
      queryKey: ['GetContractDetail', id] as const,
      queryFn: () => contractAPI.detail(id),
    }) as const satisfies QueryOptions,
  history: (id: number | string) =>
    ({
      queryKey: ['GetContractHistory', id] as const,
      queryFn: () => contractAPI.history(id),
    }) as const satisfies QueryOptions,
  list_student_in_class: (id: number | string) =>
    ({
      queryKey: ['GetContractInClass', id] as const,
      queryFn: () => contractAPI.list_student_in_class(id),
    }) as const satisfies QueryOptions,
  list_supplies: (id: number | string) =>
    ({
      queryKey: ['GetContractSupplies', id] as const,
      queryFn: () => contractAPI.list_supplies(id),
    }) as const satisfies QueryOptions,
  list_supplies_by_contract: (class_id: number | string, contract_id: number | string) =>
    ({
      queryKey: ['GetContractSupplies', class_id, contract_id] as const,
      queryFn: () => contractAPI.list_supplies_by_contract(class_id, contract_id),
    }) as const satisfies QueryOptions,
};
